export default __webpack_public_path__ + "static/media/toShow-4-min.bff0fa76.jpg";